import React from "react";
import { Link } from "react-router-dom";
import { Compass, ArrowRight } from "lucide-react";
import { SiteFooter } from "@/components/SiteFooter";
import { PublicHeader } from "@/components/PublicHeader";
import { Navbar } from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { Seo } from "@/components/Seo";
import { useAuth } from "@/context/AuthContext";

// Genuine unknown-public-URL surface. noindex,follow so search engines drop it from
// the index. NOTE: the SPA static host returns HTTP 200 for client-side routes, so this
// is a soft-404 (noindex) rather than a hard 404 status. See seo_audit report.
export default function NotFound() {
  const { user } = useAuth();
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col" data-testid="notfound-page">
      <Seo title="Page not found — PropertyConnect" robots="noindex,follow" />
      {user ? <Navbar /> : <PublicHeader />}
      <div className="flex-1 flex items-center justify-center px-4 py-24">
        <div className="text-center max-w-md">
          <div className="h-14 w-14 rounded-2xl bg-[#0F2C59]/5 flex items-center justify-center mx-auto">
            <Compass className="h-7 w-7 text-[#0F2C59]" />
          </div>
          <p className="mt-5 text-[11px] font-semibold uppercase tracking-[0.2em] text-[#C79A3B]">Error 404</p>
          <h1 className="font-display text-3xl font-bold text-slate-900 mt-1">This page can’t be found</h1>
          <p className="text-slate-500 mt-3 text-sm">
            The link may be broken or the page may have moved. Explore active property listings on the marketplace instead.
          </p>
          <div className="mt-7 flex items-center justify-center gap-3">
            <Link to="/marketplace" data-testid="notfound-marketplace-btn">
              <Button className="rounded-xl bg-[#0F2C59] hover:bg-[#0F2C59]/90 text-white h-11 px-6">
                Browse Marketplace <ArrowRight className="h-4 w-4 ml-2" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
      <SiteFooter />
    </div>
  );
}
